/**
 * Query params are persisted as array-like entries with one selection token per
 * group: `${groupKey}:${value}`.
 *
 * Example:
 *   ?variants=layout:2&variants=tile-style:4&states=empty-view:on
 */
export const VARIANTS_QUERY_PARAM = "variants";
export const STATES_QUERY_PARAM = "states";
export const GROUP_TOKEN_SEPARATOR = ":";
